import React, {useState} from 'react';
import {
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
  useStripe,
  useElements,
} from '@stripe/react-stripe-js';

import {Button, Form, Popup, Modal} from '@components';
import * as handlers from './handlers';
import {Props} from './types';

import './index.scss';

const Card: React.FC<Props> = props => {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [isModal, setIsModal] = useState(false);

  return (
    <div className="a__mypage-card">
      <div className="b__title">
        <Button.GoBack history={props.history} />
        クレジットカード情報
      </div>
      <div className="b__mypage-main">
        <div className="w__card-field">
          <div className="b__input sm">
            <div className="w__label">
              <Form.Label text="カード番号" />
            </div>
            <div className="w__input sm">
              <CardNumberElement />
            </div>
          </div>
          <div className="b__input sm">
            <div className="w__label">
              <Form.Label text="有効期限" />
            </div>
            <div className="w__input sm">
              <CardExpiryElement />
            </div>
          </div>
          <div className="b__input sm">
            <div className="w__label">
              <Form.Label text="セキュリティーコード" />
              <Popup.Normal content="カードの裏面または表面に記載されている3桁もしくは4桁の数字を入力してください。" />
            </div>
            <div className="w__input">
              <CardCvcElement />
            </div>
          </div>
          <div className="w__button">
            <Button.Normal
              onClick={(event: any) => {
                if (props.me.isForceCanceled) {
                  setIsModal(true);
                } else {
                  handlers.submit(
                    event,
                    stripe,
                    elements,
                    CardNumberElement,
                    setLoading,
                    props.history,
                    props.me,
                    props.actions,
                    setIsModal
                  );
                }
              }}
              text="登録する"
              color="green"
              className="b__edit"
              loading={loading}
              disabled={loading}
            />
          </div>
        </div>
      </div>
      <Modal.Normal
        size="xs"
        handleCloseModal={setIsModal}
        isModal={isModal}
        title="決済の確認"
        message="以前決済に失敗している為、カードの変更と同時に決済を行います。よろしいですか？"
        buttonColor="yellow"
        buttonText="カードを変更して決済する"
        loading={loading}
        disabled={loading}
        onSubmit={(event: any) => {
          handlers.submit(
            event,
            stripe,
            elements,
            CardNumberElement,
            setLoading,
            props.history,
            props.me,
            props.actions,
            setIsModal
          );
        }}
      />
    </div>
  );
};

export default Card;
